//
// Software Name: Orange Design System Charts
// SPDX-FileCopyrightText: Copyright (c) 2023 - 2026 Orange SA
// SPDX-License-Identifier: MIT
//
// This software is distributed under the MIT license.
//
export const DEFAULT_COLORS_BLUE = {
    color: [
        'var(--ods-blue-1, #085EBD)',
        'var(--ods-blue-2, #237ECA)',
        'var(--ods-blue-3, #3E9DD6)',
        'var(--ods-blue-4, #4BB4E6)',
        'var(--ods-blue-5, #80CEEF)',
        'var(--ods-blue-6, #B5E8F7)',
    ],
};
